<template>
  <v-container
    class="pa-0 max-width-md"
  >
    <!-- {{ form.watchProps.ccEntities }}
    {{ form.openerList }} -->
    <div class="d-flex flex-wrap mt-4 mx-4 mx-md-0">
      <h2>
        {{ $t('Outbox.CreateOficio') }}
      </h2>
      <v-spacer />
      <v-btn
        class="mr-2"
        color="white"
        @click="showProgress"
      >
        {{ $t('Workflow.PresentProgress') }}
      </v-btn>
      <!-- 下載公函模板 -->
      <template v-if="$config.isWeb && templateDocs && templateDocs.length === 1">
        <v-btn
          color="white"
          @click="downloadOficioTemplate(templateDocs[0])"
        >
          {{ $t('Outbox.downloadTemplate') }}
        </v-btn>
      </template>
      <template v-if="$config.isWeb && templateDocs && templateDocs.length > 1">
        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              color="white"
              v-bind="attrs"
              v-on="on"
            >
              {{ $t('Outbox.downloadTemplate') }}
            </v-btn>
          </template>
          <v-list>
            <v-list-item
              v-for="templateDoc in templateDocs"
              :key="templateDoc.index"
              @click="downloadOficioTemplate(templateDoc)"
            >
              <v-list-item-title>{{ templateDoc.orgFileName }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </template>
    </div>
    <br>
    <v-card
      v-show="form.issueEntities.length > 0"
      class="mx-2 mx-sm-auto mb-4 pa-4"
      max-width="600"
    >
      <v-select
        v-model="form.issueEntityId"
        :items="form.issueEntities"
        item-value="id"
        :item-text="item => item.abbr + ' - ' + $chPtObjData('chinName', item)"
        hide-details
        :label="$t('Outbox.IssueEntity')"
      />
    </v-card>

    <!-- 加密文件 -->
    <s-encrypted-doc
      v-if="$config.isShowEncrypted && isEncryptEntity"
      v-model="form"
    />

    <v-stepper
      v-model="mStep"
      vertical
    >
      <v-stepper-step
        :complete="mStep > 1"
        step="1"
        editable
      >
        {{ $t('Outbox.ReceiveDept') }}
      </v-stepper-step>

      <v-stepper-content step="1">
        <s-create-step-receive-entity
          v-if="!(form.issueEntities.length > 0 && form.issueEntityId === null)"
          ref="stepReceiveEntity"
          v-model="form"
          :entities="entities"
          :selected-entity-objs="selectedEntityObjs"
          :prefilled-form="prefilledForm"
        />

        <br>
        <v-btn
          :disabled="(form.issueEntities.length > 0 && form.issueEntityId === null)"
          color="primary"
          class="mb-2"
          @click="mStep = 2"
        >
          {{ $t('TaskList.NextStep') }}
        </v-btn>
      </v-stepper-content>

      <!-- 上載公函及附件 -->
      <v-stepper-step
        :complete="mStep > 2"
        step="2"
        editable
      >
        {{ $t('Outbox.UploadOficioAndAttachment') }}
      </v-stepper-step>
      <v-stepper-content step="2">
        <s-create-step-upload-doc
          ref="fileUploadStep"
          v-model="form"
          :entities="selectedEntityObjs"
          :today="today"
        />

        <br>

        <v-btn
          color="primary"
          class="mb-2"
          @click="mStep = 3"
        >
          {{ $t('TaskList.NextStep') }}
        </v-btn>
      </v-stepper-content>

      <v-stepper-step
        :complete="mStep > 3"
        step="3"
        editable
      >
        {{ $t('Outbox.Signer') }}（{{ $t('Outbox.eSign') }}）
      </v-stepper-step>
      <v-stepper-content step="3">
        <s-create-step-signer
          v-model="form"
        />
        <br>
        <v-btn
          color="primary"
          class="mb-2"
          @click="mStep = 4"
        >
          {{ $t('TaskList.NextStep') }}
        </v-btn>
      </v-stepper-content>

      <v-stepper-step
        :complete="mStep > 4"
        step="4"
        editable
      >
        {{ $t('Outbox.LabelSample') }}
      </v-stepper-step>
      <v-stepper-content step="4">
        <s-create-step-tag v-model="form" />

        <v-btn
          color="primary"
          class="mb-2"
          @click="mStep = 5"
        >
          {{ $t('TaskList.NextStep') }}
        </v-btn>
      </v-stepper-content>

      <v-stepper-step
        step="5"
        editable
      >
        {{ $t('Outbox.UploadFile') }}
      </v-stepper-step>
      <v-stepper-content step="5">
        <s-create-step-present
          ref="presentStep"
          v-model="form"
          @uploadSuccess="onUploadSuccess"
        />
      </v-stepper-content>
    </v-stepper>
  </v-container>
</template>

<script>

import SEncryptedDoc from './components/SCreateSteps/SEncryptedDoc.vue'
import SCreateStepReceiveEntity from './components/SCreateSteps/SCreateStepReceiveEntity'
import SCreateStepTag from './components/SCreateSteps/SCreateStepTag'
import SCreateStepSigner from './components/SCreateSteps/SCreateStepSigner'
import SCreateStepUploadDoc from './components/SCreateSteps/SCreateStepUploadDoc'
import SCreateStepPresent from './components/SCreateSteps/SCreateStepPresent'
import { OUTBOX_ENTITY_SOURCE_TYPE, OUTBOX_OFICIO_TYPE, BUSINESS_CODE, SECURITY_LEVEL } from '@/constant/constant'
import outboxApi from '@/api/outbox/outbox'
import { staffModule } from '@/store/moduleName'
import systemApi from '@/api/general/system'
import datetimeUtil from '@/utils/datetimeUtil'
import arrayUtil from '@/utils/arrayUtil'
import { mapGetters, mapState } from 'vuex'
import CryptoUtil from '@/lib/g2e/CryptoUtil.js'
import { commonComponentModule } from '@/store/moduleName.js'
import { parseJwt } from '@/utils/utils'
import { getStorage } from '@/utils/storageUtil'
import jwtTokenApi from '@/api/general/jwtToken'

function getAdministrativeSupportEntities (inst) {
  outboxApi.administrativeSupportEntities(resp => {
    if (resp.status === 201 || resp.status === 200) {
      inst.form.issueEntities = resp.data
    }
  })
}

function setToday (inst) {
  systemApi.getServerDateTime(rsp => {
    inst.today = datetimeUtil.cutTime(rsp)
  })
}

// function getDefaultDocNo (inst) {
//   let defaultDocNo = 'OFI/'
//   if (inst.form.docTypesId === OUTBOX_OFICIO_TYPE.OFICIO_CIRCULAR) {
//     defaultDocNo = 'OFC/'
//   }
//   return defaultDocNo + datetimeUtil.getYear(inst.today)
// }

function setDefaultDocNo (inst) {
  // inst.form.watchProps.docNo = getDefaultDocNo(inst)
}

function getEntities (inst) {
  outboxApi.getGovEntities(OUTBOX_ENTITY_SOURCE_TYPE.APM, resp => {
    if (resp.status === 201 || resp.status === 200) {
      inst.entities = resp.data
    }
  })
}

export default {
  components: {
    SEncryptedDoc,
    SCreateStepReceiveEntity,
    SCreateStepTag,
    SCreateStepSigner,
    SCreateStepUploadDoc,
    SCreateStepPresent
  },
  props: {
    prefilledForm: {
      type: Object,
      default: null
    }
  },
  data: () => {
    return {
      test: false,
      // showEncryptEntities: [3, 105, 106, 108, 109, 110, 124, 125, 126, 129, 6194, 223, 222, 141],
      SECURITY_LEVEL,
      templateDocs: [], // { templateStorageCode: null, templateFileId: null,}
      today: null,
      mStep: 1,
      entities: [],
      form: {
        watchProps: {
          docNo: null,
          selectedEntities: [],
          ccEntities: [],
          labelTypeId: null,
          oficioDocResponse: [],
          mergePdfResponse: [],
          interpellationDocResponse: [],
          isReply: false,
          senderOficioNo: [],
          sendDate: []
        },
        groupEntities: [],
        title: null,
        docTypesId: OUTBOX_OFICIO_TYPE.OFICIO,
        signer: null,
        nextStaff: null,
        nextStaffObj: null,
        isUrgent: false,
        isDirectSendToEDocX: false,
        oficioPdfResponse: [],
        interpellationPdfResponse: [],
        attachResponse: [],
        refResponse: [],
        isOficioPDFGenerated: false,
        isInterpellationPDFGenerated: false,
        isGenerating: false,
        issueEntities: [],
        issueEntityId: null,
        issueSubunitEntityId: null,
        isCarbonCopyAttachments: true,
        carbonCopyFromEntityId: null,
        isEncryptDoc: false,
        securityLevel: SECURITY_LEVEL.SECRET,
        // dfDriveFileOpenerList: [],
        filePassword: null,
        openerList: [], // users who can open encrypted edocx
        newOpenersEuid: [],
        newOpenersObj: [], // for checking opener's public key is generated or not
        myPublicKey: null,
        myKeyPairId: null
      }
    }
  },
  computed: {
    isEncryptEntity () {
      return true// this.showEncryptEntities.includes(parseJwt(getStorage('g2e-jwt-token')).entity_id)
    },
    selectedEntities () {
      return this.form.watchProps.selectedEntities
    },
    selectedEntityObjs () {
      let result = []
      this.form.watchProps.selectedEntities.forEach(id => {
        let entityId = parseInt(id.split('-')[1])
        let entity = this.form.groupEntities.find(element => element.id === entityId)
        if (entity) { result.push(entity) }
      })
      return result
    },
    watchProps () {
      return this.form.watchProps
    },
    docTypesId () {
      return this.form.docTypesId
    },
    attachResponse () {
      return this.form.attachResponse
    },
    ...mapGetters(staffModule, {
      defaultNextStaff: 'getDefaultNextStaff'
    }),
    ...mapState(
      {
        staff: state => state[staffModule].info
      }
    )
  },
  watch: {
    today: function (val) {
      setDefaultDocNo(this)
    },
    docTypesId: function (val, oldVal) {
      // if (val !== oldVal) {
      //   let defaultDocNo = getDefaultDocNo(this)
      //   let oldDefaultDocNo = ''
      //   if (defaultDocNo.includes('OFI')) {
      //     oldDefaultDocNo = defaultDocNo.replace('OFI', 'OFC')
      //   } else {
      //     oldDefaultDocNo = defaultDocNo.replace('OFC', 'OFI')
      //   }
      //   this.form.watchProps.docNo = this.form.watchProps.docNo.replace(oldDefaultDocNo, defaultDocNo)
      // }
    },
    selectedEntities: function (val) {
      if (val.length > 1) {
        this.form.docTypesId = OUTBOX_OFICIO_TYPE.OFICIO_CIRCULAR
      } else {
        this.form.docTypesId = OUTBOX_OFICIO_TYPE.OFICIO
      }
    },
    watchProps: {
      handler: function (val) {
        this.form.isOficioPDFGenerated = false
        this.form.isInterpellationPDFGenerated = false
        this.form.isGenerating = false
      },
      deep: true
    },
    defaultNextStaff: function (val) {
      this.form.nextStaff = val
    },
    attachResponse: function (val) {
      val.forEach(resp => {
        // let entityPrefixs = /^___\d+___/.exec(resp.name)
        let entitySuffixs = /___\d+___.pdf$/i.exec(resp.name)
        if (entitySuffixs) {
          // let entityId = parseInt(entityPrefixs[0].substring(3, entityPrefixs[0].length - 3))
          let entityId = parseInt(entitySuffixs[0].substring(3, entitySuffixs[0].length - 7))
          this.$refs.stepReceiveEntity.selectEntity(entityId)
          resp.response.entityId = entityId
        }
      })
    },
    'form.isEncryptDoc': {
      handler: function (val) {
        if (val) {
          if (!this.$config.isEncryptDynamicFlow) {
            this.form.nextStaff = this.form.signer
          }
          this.form.filePassword = CryptoUtil.generatePassword()
          this.form.watchProps.ccEntities = []
          // TEST ONLY
          // this.filePassword = window.atob('R1teUFBKLnR4WSRzWjJTJCxrbjlQe207PWhQK1dXSnt1eTtwTUpdVzUhKUMiJnxaWHxrXGF9USlpQUdWTjlTYHd2RWpRfFB0fD5nQjNgLUxwZFk+ImksTnk/M30jdztULytTbl41d3FcPzZSZGZccXRFZyh0eDluOHFFIVVcemN+UWlaNEklcUZ6RUZdVCpoQzF2Oy1TSXgoJSlEfGY4IWc5MGYlR1FueCxKIVQjfkldU1NVdzFGU3hoXTJXMjViNXMtJnlGdGR+TSk1YEFEKy1mNFM0PmdhWUpTZlUjc1tNcWBFVlwnY1VRPnYhbWdQQVpgdCNONEpRWiY+VkhGMlNtQCFVJCtAWCouRklhV0pMLW5aT2VaZThGLUtmSW1JcnpRUFlpXFBjcDYhIi9IcE8oN247SVhCMkRhVilqXnxsez05LXdSLyhkfjZXUywqWlpTQUlELXt7LWs/Py44IylMOkQjeSloTEBtcVhcbTZbQG8rLyVRZFRdLHQjRj8zdTp6TVx+TTlpQnR3KGBbYlZ6W143Mll5dFFjYSEvQi48J1NuLDRwQWR6LGR7LjwjbE1ePnktcy0obyRUVUlNNi1fXmM4YzhHLG1MR0tlST5AUi1SamBHPUVSLTFLMVIma2R9Q3VeOlwtZS0vcW90WDU1VnxhSk9TfkooQEcmbjVuQENAMDRZekdiJCFhLStyWU5VMCNHfA==')
          // console.log(this.filePassword)

          // let publicKey = getPublicKeyFromServer() // TODO
          //           let publicKey = `-----BEGIN PGP PUBLIC KEY BLOCK-----

          // xjMEYdK+yRYJKwYBBAHaRw8BAQdAzLB+PqcDdvFbHfFkFV4Y/vq72HuzLUO0
          // 0ddEQS6P14XNAMKMBBAWCgAdBQJh0r7JBAsJBwgDFQgKBBYBAgACGQECGwMC
          // HgEAIQkQjObL2OtSnhoWIQREkxf7sKN5De73EKaM5svY61KeGhKsAP9E9WdW
          // O+h4YRGaQIzbL1tVFTS9umBFQv2Enz81Q/uKGgD+Nuv/s5Y/IK6ZfQHxJY4k
          // 0up9Gmtjgf2pBD19Hqq/9AzOOARh0r7JEgorBgEEAZdVAQUBAQdA/KHbtMcV
          // dfL8nB+X1n4BdSo2KQVgLeLDT3PkNR402lQDAQgHwngEGBYIAAkFAmHSvskC
          // GwwAIQkQjObL2OtSnhoWIQREkxf7sKN5De73EKaM5svY61KeGi8iAQDO8mU0
          // dIpkH/R+ouDs8nhb1a6CC2fNNLTc0m0hYBNKUwD9F4ZAnhl1j19BhyuS4ZI7
          // I153VCC+fvkcY62aFysFiQA=
          // =sYn+
          // -----END PGP PUBLIC KEY BLOCK-----
          // `
          //           this.form.dfDriveFileOpenerList.push({
          //             euid: 'EU00000TEST',
          //             name_tc: 'STAFF Test',
          //             name_pt: 'STAFF Test Pt',
          //             keyPairId: 7,
          //             openerKey: await CryptoUtil.PGPTool.encryptText(this.filePassword, publicKey)
          //           })
          //           this.$store.commit(commonComponentModule + '/setEncryptedFileKey', this.dfDriveFileOpenerList[0].openerKey) // testing
        } else {
          this.form.filePassword = null
          // this.form.dfDriveFileOpenerList = []
        }
      },
      immediate: true
    }
  },
  async created () {
    if (!this.staff) {
      await this.$store.dispatch(staffModule + '/getStaff')
    }
    await this.getMyPublicKey()
    this.$store.dispatch(staffModule + '/loadDefaultNextStaff')
    getEntities(this)
    setToday(this)
    this.getOficioTemplate()
    getAdministrativeSupportEntities(this)
  },
  mounted () {
    this.importPrefilledForm()
  },
  methods: {
    async getMyPublicKey () {
      await jwtTokenApi.getPublicKeys([parseJwt(getStorage('g2e-jwt-token')).euid], resp => {
        if (resp.status === 201 || resp.status === 200) {
          if (!arrayUtil.isArrayEmptyOrNull(resp.data)) {
            this.form.myPublicKey = resp.data[0].publicKey
            this.form.myKeyPairId = resp.data[0].id
          } else {
            this.form.myPublicKey = null
            this.form.myKeyPairId = -1
          }
        }
      })
    },
    importPrefilledForm () {
      if (this.prefilledForm) {
        this.form.watchProps.docNo = this.prefilledForm.refDocNo
        this.form.watchProps.ccEntities = this.genCcEntities(this.prefilledForm)
        this.form.watchProps.labelTypeId = this.prefilledForm.labelTypeId
        this.form.watchProps.isReply = !arrayUtil.isArrayEmptyOrNull(this.prefilledForm.replyDates) || !arrayUtil.isArrayEmptyOrNull(this.prefilledForm.replyRefDocNos)
        this.form.watchProps.senderOficioNo = this.genSenderOficioNo(this.prefilledForm)
        this.form.watchProps.sendDate = this.genSendDate(this.prefilledForm)

        this.form.title = this.prefilledForm.title
        this.form.signer = this.prefilledForm.signer
        this.form.nextStaff = this.prefilledForm.handler ? this.prefilledForm.handler : this.prefilledForm.handlerGroupId
        this.form.isUrgent = this.prefilledForm.isUrgent
        this.form.isDirectSendToEDocX = this.prefilledForm.isDirectSendToEDocX
        this.form.issueEntityId = this.prefilledForm.issueEntityId
        this.form.issueSubunitEntityId = this.prefilledForm.issueSubunitEntityId
        this.setPrefilledFile(this.prefilledForm)
      }
    },
    genSenderOficioNo (prefilledForm) {
      let result = []
      prefilledForm.replyRefDocNos.forEach(item => {
        result.push(item.replyRefDocNo)
      })
      return result
    },
    genSendDate (prefilledForm) {
      let result = []
      prefilledForm.replyDates.forEach(item => {
        result.push(item.replyDate)
      })
      return result
    },
    setPrefilledFile (prefilledForm) {
      let oficioFile = []
      if (prefilledForm.docUploadFileId) {
        oficioFile.push(this.getMockUploadFileObj(prefilledForm.docOrgFileName, prefilledForm.docUploadFileId, prefilledForm.docDocumentStorageCode, null))
      }
      let combineFile = []
      if (!arrayUtil.isArrayEmptyOrNull(prefilledForm.mergeToMainDocDocuments)) {
        prefilledForm.mergeToMainDocDocuments.forEach(doc => {
          combineFile.push(this.getMockUploadFileObj(doc.orgFileName, doc.uploadFileId, doc.documentStorageCode, null))
        })
      }
      let attachFile = []
      if (!arrayUtil.isArrayEmptyOrNull(prefilledForm.attachments)) {
        prefilledForm.attachments.forEach(doc => {
          attachFile.push(this.getMockUploadFileObj(doc.orgFileName, doc.uploadFileId, doc.documentStorageCode, doc.receiveEntityId))
        })
      }
      let refFile = []
      if (!arrayUtil.isArrayEmptyOrNull(prefilledForm.references)) {
        prefilledForm.references.forEach(doc => {
          refFile.push(this.getMockUploadFileObj(doc.orgFileName, doc.uploadFileId, doc.documentStorageCode, doc.receiveEntityId))
        })
      }
      let signAttachFile = []
      if (!arrayUtil.isArrayEmptyOrNull(prefilledForm.signAttachments)) {
        signAttachFile.push(this.getMockUploadFileObj(prefilledForm.signAttachments[0].wordDisplayName + '.' + prefilledForm.signAttachments[0].wordFileExtension, prefilledForm.signAttachments[0].wordUploadFileId, prefilledForm.signAttachments[0].wordInstanceCode, null))
      }
      this.$refs.fileUploadStep.setFile(oficioFile, combineFile, attachFile, refFile, signAttachFile)
    },
    getMockUploadFileObj (filename, uploadFileId, documentStorageCode, entityId) {
      let file = { fileObject: true,
        name: filename,
        active: false,
        success: true,
        file: {},
        response: { id: uploadFileId, instanceCode: documentStorageCode, entityId: entityId },
        progress: '100.00',
        id: documentStorageCode }
      return file
    },
    genCcEntities (prefilledForm) {
      let result = []
      prefilledForm.carbonCopyEntities.forEach(entity => {
        result.push(entity.entityId)
      })
      return result
    },
    showProgress () {
      let progressOption = {
        showEndTask: true,
        businessCodes: [BUSINESS_CODE.OFICIO],
        backLink: '/outbox/Create'
      }
      // this.setProgressOption(progressOption)
      this.$router.push({
        path: '/workflow/List',
        query: progressOption
      })
    },
    onUploadSuccess () {
      this.resetForm()
    },
    resetForm () {
      let f = this.form
      let p = f.watchProps
      p.docNo = null
      setDefaultDocNo(this)
      p.selectedEntities = []
      p.ccEntities = []
      p.labelTypeId = null
      p.oficioDocResponse = []
      p.mergePdfResponse = []
      p.interpellationDocResponse = []
      p.isReply = false
      p.senderOficioNo = []
      p.sendDate = []

      f.title = null
      f.docTypesId = OUTBOX_OFICIO_TYPE.OFICIO
      f.signer = null
      f.nextStaff = this.defaultNextStaff
      f.isUrgent = false
      f.isDirectSendToEDocX = false
      f.oficioPdfResponse = []
      f.interpellationPdfResponse = []
      f.attachResponse = []
      f.refResponse = []
      f.isOficioPDFGenerated = false
      f.isInterpellationPDFGenerated = false
      f.isGenerating = false
      // f.issueEntities = []
      f.issueEntityId = null
      // f.issueSubunitEntityId = null
      this.mStep = 1
      this.$refs.fileUploadStep.clearFile()
      f.isCarbonCopyAttachments = true
      f.carbonCopyFromEntityId = null
      f.openerList = []
      f.newOpenersEuid = []
      f.newOpenersObj = []
      if (f.myPublicKey) {
        f.openerList.push({
          euid: this.staff.euid,
          chinName: this.staff.chinName,
          portName: this.staff.portName
        })
      }

      this.$store.commit(commonComponentModule + '/clearSecurityFileKeys')
    },
    getOficioTemplate () {
      outboxApi.getOficioTemplate_v2(resp => {
        if (resp.status === 201 || resp.status === 200) {
          this.templateDocs = resp.data
        }
      })
    },
    downloadOficioTemplate (templateDoc) {
      outboxApi.downloadFile((resp, fileExtension) => {
        if (resp.status === 201 || resp.status === 200) {
          const url = window.URL.createObjectURL(new Blob([resp.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', 'template.' + fileExtension)
          link.click()
          window.URL.revokeObjectURL(url)
        }
      }, templateDoc.documentStorageCode, templateDoc.id)
    }
  }
}
</script>
